(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("chroma-js"), require("../../components/Loading"));
	else if(typeof define === 'function' && define.amd)
		define(["chroma-js", "../../components/Loading"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("chroma-js"), require("../../components/Loading")) : factory(root["chroma-js"], root["../../components/Loading"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 